import { render, staticRenderFns } from "./oilcardInfo.vue?vue&type=template&id=0f66d043&scoped=true&"
import script from "./oilcardInfo.vue?vue&type=script&lang=js&"
export * from "./oilcardInfo.vue?vue&type=script&lang=js&"
import style0 from "./oilcardInfo.vue?vue&type=style&index=0&id=0f66d043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66d043",
  null
  
)

export default component.exports